import { Routes, RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FormsModule } from "@angular/forms";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { NgxSpinnerModule } from "ngx-spinner";
import { WebcamModule } from "ngx-webcam";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import type { FaceTecSDK as FaceTecSDKType } from "../assets/core-sdk/FaceTecSDK.js/FaceTecSDK";
import { ToastrModule, provideToastr } from "ngx-toastr";
import { HomeComponent } from "./pages/home/home.component";
import { ConsentComponent } from "./pages/consent/consent.component";
import { CommonModule } from "@angular/common";
import { CustomToggleComponent } from "./components/toggle/custom-toggle.component";
import { HeaderComponent } from "./components/header/header.component";
import { CustomTextFieldComponent } from "./components/textfield/custom-textfield.component";
import { RefService } from "./service/ref.service";
import { ConfigService } from "./service/config.service";
import { DataService } from "./service/data.service";
import { FacetecSDKService } from "./service/facetec.sdk.service";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { LanguageSwitcherComponent } from "./components/language-switcher/language-switcher.component";
import { TermsAndConditionsComponent } from "./pages/terms-and-conditions/terms-and-conditions.component";
import { SuccessComponent } from "./pages/success/success.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { DashboardUserService } from "./service/dashboard.user.service";
import { DashboardLoginComponent } from "./components/dashboard/login/login.component";
import { PackageCardComponent } from './pages/home/package-card/package-card.component';
import { PackageDataLoaderService } from "./pages/home/services/package.lov.data.loader.service";
import { SignatureComponent } from "./pages/signature/signature.component";

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

const routes: Routes = [
    { path: "", component: HomeComponent },
    { path: "home", component: HomeComponent },
    { path: "consent", component: ConsentComponent },
    { path: "sign", component: SignatureComponent },
    { path: "terms", component: TermsAndConditionsComponent },
    { path: "success", component: SuccessComponent },
    { path: "dashboard", component: DashboardComponent },
];

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        ConsentComponent,
        CustomToggleComponent,
        CustomTextFieldComponent,
        HeaderComponent,
        LanguageSwitcherComponent,
        TermsAndConditionsComponent,
        SuccessComponent,
        DashboardComponent,
        DashboardLoginComponent,
        PackageCardComponent,
        PackageCardComponent,
        SignatureComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        NgbModule,
        WebcamModule,
        ZXingScannerModule,
        FontAwesomeModule,
        FormsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        RouterModule.forRoot(routes, { useHash: false }),
        BrowserAnimationsModule,
        NgxSpinnerModule,
        ToastrModule.forRoot(),
    ],
    exports: [RouterModule, NgxSpinnerModule],
    bootstrap: [AppComponent],
    providers: [
        RefService,
        ConfigService,
        DataService,
        FacetecSDKService,
        DashboardUserService,
        PackageDataLoaderService,
        provideAnimations(), // required animations providers
        provideToastr(), // Toastr providers
    ],
})
export class AppModule {}

declare global {
    const FaceTecSDK: typeof FaceTecSDKType;
}
